// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__R1lFT","col":"Table_col__3-a1_","fulfillmentStatus":"Table_fulfillmentStatus__LQccd","emailCol":"Table_emailCol__3eVjU"};